module.exports = {
	"job": {
		"lang": "en",
		"user_id": 46548,
		"name": "vlog_competition.mp3",
		"duration": 90,
		"created_at": "Fri Jul 27 20:12:03 2018",
		"id": 8856519
	},
	"speakers": [
		{
			"duration": "17.51",
			"confidence": null,
			"name": "F1",
			"time": "0.15"
		},
		{
			"duration": "7.75",
			"confidence": null,
			"name": "F2",
			"time": "18.01"
		},
		{
			"duration": "63.92",
			"confidence": null,
			"name": "F1",
			"time": "26.00"
		}
	],
	"words": [
		{
			"duration": "0.19",
			"confidence": "1.000",
			"name": "Hey",
			"time": "0.15"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "guys",
			"time": "0.36"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "doing",
			"time": "1.53"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "1.74"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "blog",
			"time": "1.80"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "today",
			"time": "2.10"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "for",
			"time": "2.37"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "you",
			"time": "2.58"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "for",
			"time": "2.82"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "3.15"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "contest",
			"time": "3.21"
		},
		{
			"duration": "0.38",
			"confidence": "0.530",
			"name": ".",
			"time": "3.90"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "Shrinking",
			"time": "4.62"
		},
		{
			"duration": "0.27",
			"confidence": "0.930",
			"name": "jeans",
			"time": "5.13"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "is",
			"time": "5.40"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "having",
			"time": "5.52"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "5.76"
		},
		{
			"duration": "0.30",
			"confidence": "0.610",
			"name": "heart",
			"time": "5.82"
		},
		{
			"duration": "0.09",
			"confidence": "0.950",
			"name": "a",
			"time": "6.12"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "blogging",
			"time": "6.21"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "contest",
			"time": "6.63"
		},
		{
			"duration": "0.36",
			"confidence": "0.990",
			"name": "and",
			"time": "7.32"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "we're",
			"time": "7.68"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "supposed",
			"time": "7.80"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "8.07"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "share",
			"time": "8.19"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "our",
			"time": "8.58"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "favorite",
			"time": "8.73"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "holiday",
			"time": "9.78"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "tradition",
			"time": "10.20"
		},
		{
			"duration": "0.26",
			"confidence": "0.730",
			"name": ".",
			"time": "11.00"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "And",
			"time": "11.37"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "one",
			"time": "11.85"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "12.00"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "my",
			"time": "12.06"
		},
		{
			"duration": "0.33",
			"confidence": "0.990",
			"name": "favorite",
			"time": "12.24"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "traditions",
			"time": "12.57"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "is",
			"time": "13.29"
		},
		{
			"duration": "0.24",
			"confidence": "0.670",
			"name": "Pany",
			"time": "13.83"
		},
		{
			"duration": "0.12",
			"confidence": "0.900",
			"name": "of",
			"time": "14.07"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "14.19"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "Christmas",
			"time": "14.28"
		},
		{
			"duration": "0.17",
			"confidence": "0.940",
			"name": "tree",
			"time": "14.64"
		},
		{
			"duration": "0.04",
			"confidence": "0.590",
			"name": "at",
			"time": "14.81"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "Christmas",
			"time": "14.85"
		},
		{
			"duration": "0.39",
			"confidence": "0.770",
			"name": ".",
			"time": "15.51"
		},
		{
			"duration": "0.21",
			"confidence": "0.630",
			"name": "And",
			"time": "15.98"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "this",
			"time": "16.20"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "is",
			"time": "16.35"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "our",
			"time": "16.59"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "Christmas",
			"time": "16.86"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "tree",
			"time": "17.25"
		},
		{
			"duration": "0.08",
			"confidence": "0.880",
			"name": ".",
			"time": "17.58"
		},
		{
			"duration": "0.11",
			"confidence": "0.940",
			"name": "And",
			"time": "18.01"
		},
		{
			"duration": "0.10",
			"confidence": "1.000",
			"name": "I",
			"time": "18.14"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "thought",
			"time": "18.24"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "18.45"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "would",
			"time": "18.51"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "share",
			"time": "18.66"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "with",
			"time": "18.87"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you",
			"time": "18.99"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "guys",
			"time": "19.08"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "one",
			"time": "19.80"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "19.95"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "my",
			"time": "20.01"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "favorite",
			"time": "20.13"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "ornaments",
			"time": "20.46"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "this",
			"time": "22.13"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "was",
			"time": "22.55"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "actually",
			"time": "22.76"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "made",
			"time": "23.12"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "for",
			"time": "23.33"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "me",
			"time": "23.48"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "by",
			"time": "23.66"
		},
		{
			"duration": "0.52",
			"confidence": "0.350",
			"name": "Trena",
			"time": "23.87"
		},
		{
			"duration": "0.05",
			"confidence": "0.940",
			"name": ".",
			"time": "24.39"
		},
		{
			"duration": "0.15",
			"confidence": "0.980",
			"name": "Hey",
			"time": "24.59"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "Dana",
			"time": "24.74"
		},
		{
			"duration": "0.42",
			"confidence": "0.640",
			"name": ".",
			"time": "25.34"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "And",
			"time": "26.00"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "we",
			"time": "26.66"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "went",
			"time": "26.81"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "26.93"
		},
		{
			"duration": "0.18",
			"confidence": "0.970",
			"name": "see",
			"time": "27.02"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "New",
			"time": "27.20"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "Moon",
			"time": "27.41"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "together",
			"time": "27.65"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "last",
			"time": "28.04"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "year",
			"time": "28.43"
		},
		{
			"duration": "0.03",
			"confidence": "0.770",
			"name": ".",
			"time": "28.55"
		},
		{
			"duration": "0.18",
			"confidence": "0.990",
			"name": "And",
			"time": "28.58"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "so",
			"time": "28.76"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "she",
			"time": "28.91"
		},
		{
			"duration": "0.27",
			"confidence": "0.980",
			"name": "had",
			"time": "29.15"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "painted",
			"time": "29.42"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "this",
			"time": "30.59"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "ornament",
			"time": "30.80"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "31.43"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "31.58"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "think",
			"time": "31.67"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "it's",
			"time": "31.82"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "gorgeous",
			"time": "32.00"
		},
		{
			"duration": "0.03",
			"confidence": "0.840",
			"name": ".",
			"time": "32.51"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "And",
			"time": "32.54"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "32.66"
		},
		{
			"duration": "0.18",
			"confidence": "0.870",
			"name": "kept",
			"time": "32.75"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "telling",
			"time": "32.93"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "her",
			"time": "33.20"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "she",
			"time": "33.32"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "should",
			"time": "33.47"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "go",
			"time": "33.65"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "into",
			"time": "33.77"
		},
		{
			"duration": "0.31",
			"confidence": "1.000",
			"name": "business",
			"time": "33.95"
		},
		{
			"duration": "0.03",
			"confidence": "0.800",
			"name": ".",
			"time": "34.26"
		},
		{
			"duration": "0.13",
			"confidence": "0.950",
			"name": "But",
			"time": "34.32"
		},
		{
			"duration": "0.40",
			"confidence": "0.610",
			"name": "Anyways",
			"time": "34.51"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "that's",
			"time": "35.84"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "my",
			"time": "36.17"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "favorite",
			"time": "36.56"
		},
		{
			"duration": "0.33",
			"confidence": "0.980",
			"name": "holiday",
			"time": "36.98"
		},
		{
			"duration": "0.62",
			"confidence": "1.000",
			"name": "tradition",
			"time": "37.31"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "and",
			"time": "38.21"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "my",
			"time": "38.75"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "favorite",
			"time": "38.99"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "recipe",
			"time": "39.38"
		},
		{
			"duration": "0.09",
			"confidence": "0.520",
			"name": "they're",
			"time": "39.90"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "going",
			"time": "40.01"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "40.13"
		},
		{
			"duration": "0.23",
			"confidence": "0.920",
			"name": "share",
			"time": "40.19"
		},
		{
			"duration": "0.08",
			"confidence": "0.660",
			"name": "if",
			"time": "40.43"
		},
		{
			"duration": "0.10",
			"confidence": "0.810",
			"name": "you",
			"time": "40.51"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "guys",
			"time": "40.61"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "is",
			"time": "41.57"
		},
		{
			"duration": "0.28",
			"confidence": "1.000",
			"name": "fruit",
			"time": "42.40"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "salad",
			"time": "42.68"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "43.40"
		},
		{
			"duration": "0.17",
			"confidence": "0.630",
			"name": "this",
			"time": "43.55"
		},
		{
			"duration": "0.38",
			"confidence": "0.860",
			"name": "actually",
			"time": "43.72"
		},
		{
			"duration": "0.06",
			"confidence": "0.610",
			"name": "is",
			"time": "44.11"
		},
		{
			"duration": "0.34",
			"confidence": "0.900",
			"name": "something",
			"time": "44.23"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "that",
			"time": "44.57"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "44.69"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "got",
			"time": "44.75"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "from",
			"time": "44.99"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "my",
			"time": "45.14"
		},
		{
			"duration": "0.31",
			"confidence": "1.000",
			"name": "mother",
			"time": "45.59"
		},
		{
			"duration": "0.45",
			"confidence": "0.590",
			"name": "Kathy",
			"time": "46.08"
		},
		{
			"duration": "0.42",
			"confidence": "0.700",
			"name": ".",
			"time": "46.56"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "And",
			"time": "47.12"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "you",
			"time": "47.51"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "can",
			"time": "47.66"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "use",
			"time": "47.84"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "any",
			"time": "48.14"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "kind",
			"time": "48.38"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "48.59"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "fruit",
			"time": "48.68"
		},
		{
			"duration": "0.75",
			"confidence": "0.710",
			"name": "combinations",
			"time": "48.92"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "so",
			"time": "49.67"
		},
		{
			"duration": "0.35",
			"confidence": "0.810",
			"name": "not",
			"time": "51.38"
		},
		{
			"duration": "0.30",
			"confidence": "0.920",
			"name": "not",
			"time": "51.89"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "52.19"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "real",
			"time": "52.25"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "true",
			"time": "52.58"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "recipe",
			"time": "52.85"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "I",
			"time": "53.30"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "guess",
			"time": "53.36"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "because",
			"time": "53.57"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "it's",
			"time": "53.75"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "something",
			"time": "53.99"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you",
			"time": "54.35"
		},
		{
			"duration": "0.12",
			"confidence": "0.960",
			"name": "do",
			"time": "54.44"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "yourself",
			"time": "54.56"
		},
		{
			"duration": "0.10",
			"confidence": "0.840",
			"name": ".",
			"time": "55.19"
		},
		{
			"duration": "0.20",
			"confidence": "0.810",
			"name": "But",
			"time": "55.64"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "57.68"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "think",
			"time": "57.77"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "we",
			"time": "58.19"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "normally",
			"time": "58.34"
		},
		{
			"duration": "0.19",
			"confidence": "0.840",
			"name": "put",
			"time": "58.85"
		},
		{
			"duration": "1.14",
			"confidence": "1.000",
			"name": "pineapple",
			"time": "59.33"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "and",
			"time": "60.56"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "grapes",
			"time": "61.01"
		},
		{
			"duration": "0.54",
			"confidence": "0.990",
			"name": "and",
			"time": "61.79"
		},
		{
			"duration": "0.90",
			"confidence": "1.000",
			"name": "apples",
			"time": "62.33"
		},
		{
			"duration": "0.27",
			"confidence": "0.880",
			"name": "cut",
			"time": "63.26"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "up",
			"time": "63.53"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "and",
			"time": "64.39"
		},
		{
			"duration": "0.09",
			"confidence": "0.960",
			"name": "you",
			"time": "64.52"
		},
		{
			"duration": "0.12",
			"confidence": "0.820",
			"name": "just",
			"time": "64.61"
		},
		{
			"duration": "0.19",
			"confidence": "1.000",
			"name": "put",
			"time": "64.75"
		},
		{
			"duration": "0.09",
			"confidence": "0.960",
			"name": "in",
			"time": "64.94"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "whatever",
			"time": "65.03"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "65.39"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "want",
			"time": "65.51"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "whatever",
			"time": "65.84"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "66.14"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "like",
			"time": "66.26"
		},
		{
			"duration": "0.03",
			"confidence": "0.850",
			"name": ".",
			"time": "66.53"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "It's",
			"time": "66.56"
		},
		{
			"duration": "0.06",
			"confidence": "0.920",
			"name": "a",
			"time": "67.20"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "truly",
			"time": "67.28"
		},
		{
			"duration": "0.48",
			"confidence": "0.290",
			"name": "coz",
			"time": "67.67"
		},
		{
			"duration": "0.68",
			"confidence": "0.710",
			"name": "cousin",
			"time": "68.19"
		},
		{
			"duration": "0.38",
			"confidence": "0.620",
			"name": "because",
			"time": "69.10"
		},
		{
			"duration": "0.52",
			"confidence": "1.000",
			"name": "whatever",
			"time": "69.73"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you",
			"time": "70.46"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "can",
			"time": "70.55"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "customize",
			"time": "70.67"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "it",
			"time": "71.27"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "and",
			"time": "72.02"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "throw",
			"time": "72.44"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "in",
			"time": "72.65"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "some",
			"time": "72.77"
		},
		{
			"duration": "0.61",
			"confidence": "1.000",
			"name": "nuts",
			"time": "72.95"
		},
		{
			"duration": "0.26",
			"confidence": "1.000",
			"name": "or",
			"time": "73.59"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "whatever",
			"time": "73.85"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "else",
			"time": "74.33"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "74.63"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "want",
			"time": "74.75"
		},
		{
			"duration": "0.45",
			"confidence": "0.960",
			"name": "to",
			"time": "74.93"
		},
		{
			"duration": "0.39",
			"confidence": "0.830",
			"name": ".",
			"time": "75.39"
		},
		{
			"duration": "0.18",
			"confidence": "0.930",
			"name": "But",
			"time": "76.00"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "anyways",
			"time": "76.19"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "that's",
			"time": "77.18"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "77.39"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "good",
			"time": "77.45"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "thing",
			"time": "77.69"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "77.93"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "have",
			"time": "77.99"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "around",
			"time": "78.29"
		},
		{
			"duration": "0.03",
			"confidence": "0.610",
			"name": ".",
			"time": "78.71"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "And",
			"time": "78.74"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "we",
			"time": "78.98"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "have",
			"time": "79.16"
		},
		{
			"duration": "0.18",
			"confidence": "0.760",
			"name": "a",
			"time": "79.37"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "more",
			"time": "79.73"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "than",
			"time": "79.97"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "just",
			"time": "80.12"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "holidays",
			"time": "80.39"
		},
		{
			"duration": "0.08",
			"confidence": "0.530",
			"name": ".",
			"time": "81.28"
		},
		{
			"duration": "0.10",
			"confidence": "0.640",
			"name": "I've",
			"time": "81.48"
		},
		{
			"duration": "0.26",
			"confidence": "0.830",
			"name": "had",
			"time": "81.78"
		},
		{
			"duration": "0.12",
			"confidence": "0.730",
			"name": "it",
			"time": "82.04"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "random",
			"time": "82.19"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "times",
			"time": "82.70"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "83.06"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "83.15"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "year",
			"time": "83.24"
		},
		{
			"duration": "0.32",
			"confidence": "0.990",
			"name": "too",
			"time": "83.42"
		},
		{
			"duration": "0.17",
			"confidence": "0.860",
			"name": "but",
			"time": "84.11"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "it's",
			"time": "84.29"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "something",
			"time": "84.44"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "that",
			"time": "85.43"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "is",
			"time": "85.79"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "can",
			"time": "86.33"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "be",
			"time": "86.51"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "kind",
			"time": "86.63"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "86.81"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "sweet",
			"time": "86.90"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "and",
			"time": "87.92"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "it",
			"time": "88.13"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "gets",
			"time": "88.19"
		},
		{
			"duration": "0.06",
			"confidence": "0.560",
			"name": "in",
			"time": "88.40"
		},
		{
			"duration": "0.09",
			"confidence": "0.790",
			"name": "your",
			"time": "88.49"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "fruit",
			"time": "88.58"
		},
		{
			"duration": "0.65",
			"confidence": "0.990",
			"name": "servings",
			"time": "89.21"
		},
		{
			"duration": "0.06",
			"confidence": "0.580",
			"name": "in",
			"time": "89.86"
		},
		{
			"duration": "0.00",
			"confidence": "1.000",
			"name": ".",
			"time": "89.92"
		}
	],
	"format": "1.0"
};


//////////////////
// WEBPACK FOOTER
// ./src/vlog_competition.json
// module id = 32
// module chunks = 0